<template>
  <div>
    <b-card :header="titulo">
      <b-table 
          small 
          class="datos-objeto" 
          responsive="sm" 
          :items="datos" 
          :fields="fields">
        <template v-slot:cell(valor)="data">
          {{ formattedData(data.item) }}
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'tableData',
  props: {
    titulo: {
      type: String,
      default: ''
    },
    datos: {
      type: Array,
      default: null
    }
  },
  data: () => {
    return {
      fields: [
        {key: 'campo'},
        {key: 'valor'},
      ],
    }
  },
}
</script>
